import jovenOrtodoncia from '../Pages/images/img_ortodoncia/joven-ortodoncia.png';
import cuscoBrackets from '../Pages/images/img_ortodoncia/cusco-brackets.png';
import imgInvisalign from '../Pages/images/img_ortodoncia/invisalign.png';
import imgGermanPaniura from '../Pages/images/img_ortodoncia/german-paniura.png';
import imgMicroImplante from '../Pages/images/img_tratamientos/micro-implante-512x512.png';
import imgRetenedores from '../Pages/images/img_tratamientos/retenedores-512x512.png';
import imgFilosofia from '../Pages/images/img_filosofia/img_filosofia.png';
import imgInternacionalOrtodoncia from '../Pages/images/img_internacional/ortodoncia-cusco.jpg';
import imgAppointment from '../Pages/images/admin_images/appointment_admin_img.png';
import imgBracketsAutoligantes from '../Pages/images/img_tratamientos/brackets-autoligantes.png';
import imgKlammt from '../Pages/images/img_tratamientos/KLAMMT.png';
import imgBimler from '../Pages/images/img_tratamientos/BIMLER.png';
import imgPlanas from '../Pages/images/img_tratamientos/PLANAS.png';
import imgStockfisch from '../Pages/images/img_tratamientos/STOCKFISCH.png';
import imgClarkTwinBlock from '../Pages/images/img_tratamientos/CLARK.png';
import imgTeensThree from '../Pages/images/img_blog/Teens_three.jpg';

const TRANSPARENT_HERO = { transparent: true };

/** Páginas con hero split + main al 50% (mismo layout que brackets metálicos). */
const ORTHO_PAGE_HERO_IMAGES = {
  metalBraces: { src: jovenOrtodoncia, ...TRANSPARENT_HERO },
  ceramicBraces: { src: cuscoBrackets, ...TRANSPARENT_HERO },
  invisalign: { src: imgInvisalign, ...TRANSPARENT_HERO },
  selfLigatingBraces: { src: imgBracketsAutoligantes, ...TRANSPARENT_HERO },
  klamm: { src: imgKlammt, ...TRANSPARENT_HERO },
  bimler: { src: imgBimler, ...TRANSPARENT_HERO },
  planas: { src: imgPlanas, ...TRANSPARENT_HERO },
  stockfisch: { src: imgStockfisch, ...TRANSPARENT_HERO },
  clarkTwinBlock: { src: imgClarkTwinBlock, ...TRANSPARENT_HERO },
  retainers: { src: imgRetenedores, ...TRANSPARENT_HERO, variant: 'micro' },
  miniImplants: { src: imgMicroImplante, ...TRANSPARENT_HERO, variant: 'micro' },
  thirdMolar: { src: jovenOrtodoncia, ...TRANSPARENT_HERO },
  drProfile: { src: imgGermanPaniura },
  drApproach: { src: imgFilosofia },
  drInvisalign: { src: imgInvisalign, ...TRANSPARENT_HERO },
  whySmileUp: { src: imgGermanPaniura },
  whyInternational: { src: imgInternacionalOrtodoncia },
  bookConsult: { src: imgAppointment, ...TRANSPARENT_HERO, variant: 'micro' },
  firstAppt: { src: imgTeensThree },
};

export function getOrthoPageHeroImage(pageId) {
  const entry = ORTHO_PAGE_HERO_IMAGES[pageId];
  if (!entry) return null;
  return typeof entry === 'string' ? entry : entry.src;
}

export function isOrthoPageHeroTransparent(pageId) {
  return Boolean(ORTHO_PAGE_HERO_IMAGES[pageId]?.transparent);
}

export function usesSplitHeroLayout(pageId) {
  return pageId in ORTHO_PAGE_HERO_IMAGES;
}

export function getOrthoPageHeroVariant(pageId) {
  return ORTHO_PAGE_HERO_IMAGES[pageId]?.variant || null;
}
